const mutations = {
  'SET_USER' (state, { user }) {
    localStorage.setItem('user', JSON.stringify(user))
    state.user = user
  }
}

export default mutations
